"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPLCProgram = void 0;
var UPLCVersion_1 = require("./UPLCVersion.js");
var UPLCProgram = /** @class */ (function () {
    function UPLCProgram(version, body) {
        if (Array.isArray(version)) {
            this._version = new (UPLCVersion_1.UPLCVersion.bind.apply(UPLCVersion_1.UPLCVersion, __spreadArray([void 0], __read(version), false)))();
        }
        else {
            this._version = version;
        }
        this._body = body;
    }
    Object.defineProperty(UPLCProgram.prototype, "version", {
        get: function () { return this._version; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(UPLCProgram.prototype, "body", {
        get: function () { return this._body; },
        enumerable: false,
        configurable: true
    });
    ;
    return UPLCProgram;
}());
exports.UPLCProgram = UPLCProgram;
